/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_TaglineInputs */

const en_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI systems engineering.`)
};

const lv_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI sistēmu inženierija.`)
};

/**
* | output |
* | --- |
* | "AI systems engineering." |
*
* @param {Footer_TaglineInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const footer_tagline = /** @type {((inputs?: Footer_TaglineInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_TaglineInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_footer_tagline(inputs)
	return en_footer_tagline(inputs)
});